import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Facade from "@/Facade";

export default class LoadingState extends BaseState {

  begin() {
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.loadAssets.dispatch()
    // console.log('check the state for the StateMachine:::', this.stateMachine, this)
  }

  onContinueBtnClick() {
    this.end()
  }

  end = () => {
    // console.log('check the state for the StateMachine:::', this.stateMachine, this)
    // this.stateMachine.setState(GameStatesEnum.OPEN_SOCKET)

    const proceed = () => {
      this.stateMachine.setState(Facade.initialState)

      Signals.forceRoundStart.remove(proceed)
      Signals.forceRoundEnd.remove(proceed)
      Signals.forceMakeBets.remove(proceed)
    }

    if (!Facade.initialState) {
      Signals.forceRoundStart.add(proceed, this)
      Signals.forceRoundEnd.add(proceed, this)
      Signals.forceMakeBets.add(proceed, this)
    } else {
      this.stateMachine.setState(Facade.initialState)
    }
  }

  cleanUp() {
    Signals.continueBtnClick.remove(this.onContinueBtnClick, this)
  }

}
